export const options = {
    counselTypeList: [
        { key: 1, name: "전화상담" },
        { key: 2, name: "내방상담" },
        { key: 3, name: "방문상담" },
        { key: 4, name: "사이버" },
        { key: 5, name: "아웃리치" },
        { key: 6, name: "현장상담" },
    ],

    locationList: [
        { key: "기록없음", name: "기록없음" },
        { key: "1366", name: "1366,1388 등" },
        { key: "117", name: "117" },
        { key: "홍보(인터넷,114,언론보도등)", name: "홍보(인터넷,114,언론보도등)" },
        { key: "지인소개", name: "지인소개" },
        { key: "유관기관", name: "유관기관" },
        { key: "성매매방지기관", name: "성매매방지기관" },
        { key: "학교", name: "학교" },
        { key: "검찰/경찰/법원", name: "검찰/ 경찰/ 법원" },
        { key: "기타", name: "기타" },
    ],

    introducerList: [
        { key: 1, name: "본인" },
        { key: 2, name: "가족친인척" },
        { key: 3, name: "동료/ 이웃" },
        { key: 4, name: "타기관" },
    ],

    deptList: [
        { key: 1, name: "상담팀" },
        { key: 3, name: "현장팀" },
        { key: 4, name: "기타" },
    ],

    deptListForMove: [
        { key: 1, name: "상담팀" },
        { key: 2, name: "청소년" },
        { key: 3, name: "현장팀" },
    ],

    area1List: [
        { key: 1, name: "기록없음" },
        { key: 2, name: "서울" },
        { key: 3, name: "광역시" },
        { key: 4, name: "각 도별" },
        { key: 5, name: "외국" },
    ],

    area4List: [
        { key: 1, parentKey: 2, name: "" },
        { key: 2, parentKey: 2, name: "강남구" },
        { key: 3, parentKey: 2, name: "강동구" },
        { key: 4, parentKey: 2, name: "강북구" },
        { key: 5, parentKey: 2, name: "강서구" },
        { key: 6, parentKey: 2, name: "관악구" },
        { key: 7, parentKey: 2, name: "광진구" },
        { key: 8, parentKey: 2, name: "구로구" },
        { key: 9, parentKey: 2, name: "금천구" },
        { key: 10, parentKey: 2, name: "노원구" },
        { key: 11, parentKey: 2, name: "도봉구" },
        { key: 12, parentKey: 2, name: "동대문구" },
        { key: 13, parentKey: 2, name: "동작구" },
        { key: 14, parentKey: 2, name: "마포구" },
        { key: 15, parentKey: 2, name: "서대문구" },
        { key: 16, parentKey: 2, name: "서초구" },
        { key: 17, parentKey: 2, name: "성동구" },
        { key: 18, parentKey: 2, name: "성북구" },
        { key: 19, parentKey: 2, name: "송파구" },
        { key: 20, parentKey: 2, name: "양천구" },
        { key: 21, parentKey: 2, name: "영등포구" },
        { key: 22, parentKey: 2, name: "용산구" },
        { key: 23, parentKey: 2, name: "은평구" },
        { key: 24, parentKey: 2, name: "종로구" },
        { key: 25, parentKey: 2, name: "중구" },
        { key: 26, parentKey: 2, name: "중랑구" },
    ],

    area2List: [
        { key: 1, parentKey: 3, name: "광주광역시" },
        { key: 2, parentKey: 3, name: "대구광역시" },
        { key: 3, parentKey: 3, name: "대전광역시" },
        { key: 4, parentKey: 3, name: "부산광역시" },
        { key: 5, parentKey: 3, name: "울산광역시" },
        { key: 6, parentKey: 3, name: "인천광역시" },
    ],

    area3List: [
        { key: 1, parentKey: 4, name: "강원도" },
        { key: 2, parentKey: 4, name: "경기도" },
        { key: 3, parentKey: 4, name: "경상남도" },
        { key: 4, parentKey: 4, name: "경상북도" },
        { key: 5, parentKey: 4, name: "전라남도" },
        { key: 6, parentKey: 4, name: "전라북도" },
        { key: 7, parentKey: 4, name: "제주도" },
        { key: 8, parentKey: 4, name: "충청남도" },
        { key: 9, parentKey: 4, name: "충청북도" },
    ],

    typeList: [
        { key: "기록없음", name: "기록없음" },
        { key: "집결지", name: "(전업형)집결지)" },
        { key: "오피스텔", name: "(전업형)오피스텔" },
        { key: "겸업형", name: "겸업형(기존산업형)" },
        { key: "위장형", name: "위장형(기존산업형)" },
        { key: "출장형", name: "출장형" },
        { key: "온라인", name: "온라인" },
        { key: "해외성매매", name: "해외성매매" },
        { key: "기타", name: "기타" },
    ],

    priceList: [
        { key: "기록없음", name: "기록없음" },
        { key: "없음", name: "없음" },
        { key: "300만원이하", name: "300만원 미만" },
        { key: "300~700만원", name: "300~700만원 미만" },
        { key: "700~1,000만원", name: "700~1,000만원 미만" },
        { key: "2,000~5,000만원", name: "2,000~5,000만원 미만" },
        { key: "5,000~1억원", name: "5,000~1억원 미만" },
        { key: "1억원 이상", name: "1억원 이상" },
        { key: "그외 채무", name: "그외 채무" },
    ],

    brokerList: [
        { key: "기록없음", name: "기록없음" },
        { key: "보도방", name: "보도방" },
        { key: "소개업자", name: "소개업자" },
        { key: "사채업자", name: "사채업자" },
        { key: "업주", name: "업주" },
        { key: "업소관계자", name: "업소관계자" },
        { key: "친구지인", name: "친구,지인" },
        { key: "보호자가족", name: "보호자,가족" },
        { key: "홍보물", name: "홍보물" },
        { key: "구인구직사이트", name: "구인구직사이트" },
        { key: "채팅앱", name: "채팅앱" },
        { key: "기타", name: "기타" },
    ],

    counselTypeListForCounsel: [
        { key: "전화상담", name: "전화상담" },
        { key: "내방상담", name: "내방상담" },
        { key: "방문상담", name: "방문상담" },
        { key: "사이버", name: "사이버" },
        { key: "서신", name: "서신" },
        { key: "아웃리치", name: "아웃리치" },
        { key: "온라인상담", name: "온라인상담" },
    ],

    personTargetList: [
        { key: "본인", name: "본인" },
        { key: "가족/친인척", name: "가족/친인척" },
        { key: "동료/이웃", name: "동료/이웃" },
        { key: "타기관", name: "타기관(의료법률전문가,관공서)" },
        { key: "성매매방지기관", name: "성매매방지기관" },
        { key: "유관기관", name: "유관기관(사회복지기관,상담전화)" },
        { key: "학교", name: "학교" },
        { key: "검찰/경찰/법원", name: "검찰/경찰/법원" },
        { key: "기타", name: "기타" },
    ],

    typeListForActivity: [
        { key: "온라인상담", name: "온라인상담" },
        { key: "아웃리치", name: "아웃리치" },
        { key: "성매매예방교육", name: "성매매예방교육" },
        { key: "캠페인", name: "캠페인" },
        { key: "이벤트성 행사", name: "이벤트성 행사" },
        { key: "기관연대(방문)", name: "기관연대(방문)" },
        { key: "기관연대(내방)", name: "기관연대(내방)" },
    ],

    teamForActivity: [
        { key: "상담팀", name: "상담팀" },
        { key: "현장팀", name: "현장팀" },
        { key: "행정팀", name: "행정지원팀" },
        { key: "감시팀", name: "감시사업팀" },
    ],

    schoolHistoryList: [
        { key: "", name: "선택해주세요." },
        { key: "초재", name: "초재" },
        { key: "초교중퇴", name: "초교중퇴" },
        { key: "초교졸", name: "초교졸" },
        { key: "중재", name: "중재" },
        { key: "중교중퇴", name: "중교중퇴" },
        { key: "중교졸", name: "중교졸" },
        { key: "고재", name: "고재" },
        { key: "고교중퇴", name: "고교중퇴" },
        { key: "고교졸", name: "고교졸" },
        { key: "대중퇴", name: "대중퇴" },
        { key: "대재", name: "대재" },
        { key: "대졸", name: "대졸" },
        { key: "대학원재", name: "대학원재" },
        { key: "대학원졸", name: "대학원졸" },
        { key: "기타", name: "기타" },
    ],

    accessRequestStateList: [
        { key: 0, name: "대기" },
        { key: 1, name: "승인" },
        { key: 2, name: "반려" },
        { key: 3, name: "수정완료" },
        { key: 4, name: "처리완료" },
    ],
};
